import React from 'react';
import { motion } from 'framer-motion';
import PostCard from './PostCard';
import axios from 'axios';

const CARD_MOTION = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4, ease: 'easeOut' },
};

const CommunityFeed = ({ posts, loading, user, onPostUpdate }) => {
  const handlePostLike = async (postId) => {
    try {
      const response = await axios.post(`/api/community/posts/${postId}/like`, {});

      if (response.data.status === 'success') {
        const updatedPosts = posts.map((post) => {
          if (post.id === postId) {
            return {
              ...post,
              liked: response.data.data.liked,
              likes: response.data.data.likes_count,
            };
          }
          return post;
        });
        onPostUpdate(updatedPosts);
      }
    } catch (error) {
      /* silent fail for likes */
    }
  };

  const handlePostComment = async (postId, comment) => {
    try {
      const response = await axios.post(`/api/community/posts/${postId}/comments`, {
        content: comment,
      });

      if (response.data.status === 'success') {
        const updatedPosts = posts.map((post) => {
          if (post.id === postId) {
            return { ...post, comments: (post.comments || 0) + 1 };
          }
          return post;
        });
        onPostUpdate(updatedPosts);
      }
    } catch (error) {
      alert('Failed to add comment. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="space-y-8">
        {[1, 2, 3].map((i) => (
          <div key={i} className="surface-panel p-6 animate-pulse">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-hairline rounded-lg" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-hairline rounded w-1/4" />
                <div className="h-3 bg-hairline rounded w-1/6" />
              </div>
            </div>
            <div className="space-y-2 mb-4">
              <div className="h-4 bg-hairline rounded w-full" />
              <div className="h-4 bg-hairline rounded w-3/4" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {posts.map((post, index) => (
        <motion.div
          key={post.id}
          {...CARD_MOTION}
          transition={{ ...CARD_MOTION.transition, delay: index * 0.05 }}
        >
          <PostCard
            post={post}
            user={user}
            onLike={() => handlePostLike(post.id)}
            onComment={(comment) => handlePostComment(post.id, comment)}
          />
        </motion.div>
      ))}
    </div>
  );
};

export default CommunityFeed;
